import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect, Route, Switch } from 'react-router-dom';

import PageTitle from '../../../components/pageTitle';
import Navigation from '../../../components/navigation';
import GalleryPreview from '../../../components/modules/galleryPreview';
import Pagination from '../../../components/pagination';
import flh from '../../../helpers/file.helper';


const Gallery = ({
  t,
  goToPage,
  criteria,
  chooseImg,
  groupedImages,
  imagesCount,
  backgroundColor,
  enableCoverColor,
  token,
  imgOnError,
  backgroundCover,
  moduleTitle,
}) => (
  <React.Fragment>
    <PageTitle
      title={moduleTitle}
      backgroundPage={backgroundColor}
      backgroundCover={backgroundCover}
      enableCoverColor={enableCoverColor}
    />
    <section className="Blog2 boxs dpreview">
      <div className="container">
        <div className="Blog2inner boxs pdlr">
          <Navigation cssClass="leftKB" />
          <div className="middleKB">
            <div className="middleinner boxs">
              {
                !!Object.keys(groupedImages).length &&
                (<React.Fragment>
                  <div className="kbleftwg" style={{ float: 'left' }}>
                    <div className="previewlinks boxs" style={{ float: 'left' }}>
                      {
                        Object.keys(groupedImages).map(key =>
                          (groupedImages[key].length &&
                          (<div className="plinks_inner boxs" key={key}>
                            {/* <h3>{t('Images')}</h3> */}
                            <ul className="portaltabs">
                              {
                                groupedImages[key].map(img =>
                                  (<li key={img.id} style={{ float: 'left', height: '160px', width: '220px', margin: '5px' }}>
                                    <a
                                      href="#"
                                      className="docmenttablink"
                                      onClick={e => chooseImg(e, img)}
                                      style={{ textAlign: 'center', width: '100%', height: '100%', borderRadius: '8px', display: 'inline-block' }}
                                    >
                                      <span className="img-helper" />
                                      <img src={flh.createGalleryPreviewLink(img, token)} onError={imgOnError} style={{ verticalAlign: 'middle', borderRadius: '8px', objectFit: 'cover', maxHeight: '160px', maxWidth: '220px',  }} />
                                    </a>
                                  </li>))
                                  }
                            </ul>
                          </div>)))
                      }
                      <Pagination
                        goToPage={goToPage}
                        count={imagesCount}
                        pageSize={criteria.limit}
                        page={criteria.page}
                        backgroundColor={backgroundColor}
                      />
                    </div>
                  </div>
                </React.Fragment>)
              }
              { !!Object.keys(groupedImages).length && (
                <React.Fragment>
                  <div className="">
                    <Switch>
                      <Route
                        exact
                        path="/gallery/:id"
                        render={prop =>
                          (<GalleryPreview {...prop} />)}
                      />
                      <Route
                        path="/gallery"
                        render={() => (
                          <div className="choosefile boxs chosefl chosefl0">
                            <h2 className="fontmulisemi">{t('Choose a file to preview')}</h2>
                          </div>
                        )}
                      />
                      <Redirect from="*" to="/gallery" />
                    </Switch>
                  </div>
                </React.Fragment>
              )}
              { !Object.keys(groupedImages).length && (
                <div className="kbrightw" style={{ width: '100%' }}>
                  <div className="nopreview boxs chosefl chosefl1">
                    <h2 className="fontmulisemi">{t('No images available')}</h2>
                    <div className="nopre_img boxs">
                      <img src="/img/nopreview.svg" alt="nopreview" />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  </React.Fragment>
);

Gallery.propTypes = {
  t: PropTypes.func.isRequired,
  activeDocument: PropTypes.object,
  goToPage: PropTypes.func.isRequired,
  chooseImg: PropTypes.func.isRequired,
  criteria: PropTypes.object.isRequired,
  groupedImages: PropTypes.object.isRequired,
  imagesCount: PropTypes.number.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  backgroundCover: PropTypes.number,
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/views/modules/gallery/Gallery.jsx